/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bN5uNsAhTefwW3S14VjvMG

import { createUseGlobalVariants } from "@plasmicapp/react-web";

import { useScreenVariants as useScreenVariantsqiBuxNlixBgQ } from "../paziresh_24_design_system/PlasmicGlobalVariant__Screen"; // plasmic-import: QiBUXNlixBgQ/globalVariant

export const _useGlobalVariants = createUseGlobalVariants({
  screen: useScreenVariantsqiBuxNlixBgQ
});
